"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _lodash = require("lodash");

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _viewer = require("../../services/viewer");

var _textColorUtils = require("../../services/text-color-utils");

var _searchPageUrl = require("../../services/search-page-url");

var _theme = _interopRequireDefault(require("../../services/theme"));

var _getStyle = _interopRequireDefault(require("../../services/get-style"));

var _wixSdkPolyfill = _interopRequireDefault(require("../../services/wix-sdk-polyfill"));

var _richContentViewer = _interopRequireDefault(require("./rich-content-viewer.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var anchorTarget = '_top';

var RichContentViewer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(RichContentViewer, _Component);

  var _super = _createSuper(RichContentViewer);

  function RichContentViewer(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      error: false,
      isViewerDisabled: false,
      isExpandMode: false,
      expandModeImageIndex: undefined
    });

    _defineProperty(_assertThisInitialized(_this), "enableViewer", function () {
      return _this.setState({
        isViewerDisabled: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "disableViewer", function () {
      return _this.setState({
        isViewerDisabled: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getVideoPluginConfig", function () {
      return {
        getVideoUrl: function getVideoUrl(src) {
          return _this.props.getVideoUrl(src.pathname);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onHashTagClick", function (event) {
      event.preventDefault();
      event.stopPropagation();

      _this.props.hashtagNavigate((0, _searchPageUrl.createHashtagPath)(event.target.innerText));
    });

    _defineProperty(_assertThisInitialized(_this), "onExpandImage", function (entityIndex, innerIndex) {
      if (innerIndex === void 0) {
        innerIndex = 0;
      }

      _this.setState({
        isExpandMode: true,
        expandModeImageIndex: _this.getExpandModeImages().imageMap[entityIndex] + innerIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getExpandModeImages", function () {
      if (!_this.imagesData) {
        _this.imagesData = _this.rce.getImagesData(_this.props.initialRawState);

        _this.imagesData.images.forEach(function (img) {
          if (!img.itemId) {
            img.itemId = img.url;
          }
        });
      }

      return _this.imagesData;
    });

    _defineProperty(_assertThisInitialized(_this), "onError", function (error) {
      if (!_this.state.error) {
        _this.setState({
          error: error
        });
      }
    });

    _this.initViewerProps();

    _this.Viewer = props.richContent.RichContentViewer;
    return _this;
  }

  var _proto = RichContentViewer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    _wixSdkPolyfill["default"].addEventListener(_wixSdkPolyfill["default"].Events.PAGE_NAVIGATION_IN, this.enableViewer);

    _wixSdkPolyfill["default"].addEventListener(_wixSdkPolyfill["default"].Events.PAGE_NAVIGATION_OUT, this.disableViewer);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    _wixSdkPolyfill["default"].removeEventListener(_wixSdkPolyfill["default"].Events.PAGE_NAVIGATION_IN, this.enableViewer);

    _wixSdkPolyfill["default"].removeEventListener(_wixSdkPolyfill["default"].Events.PAGE_NAVIGATION_OUT, this.disableViewer);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.props.isInEditor()) {
      this.initTheme();
    }
  };

  _proto.getImagePluginConfig = function getImagePluginConfig() {
    var _this2 = this;

    return {
      imageProps: function imageProps(src) {
        return {
          'data-pin-url': _this2.props.pageUrl,
          'data-pin-media': (0, _lodash.isString)(src) ? src : _this2.props.getImageUrl(src, _viewer.MAX_PINTEREST_IMAGE_SIZE, _viewer.MAX_PINTEREST_IMAGE_SIZE)
        };
      }
    };
  };

  _proto.initViewerProps = function initViewerProps() {
    var _this3 = this,
        _this$config;

    var _this$props = this.props,
        enableLinks = _this$props.enableLinks,
        isOneApp = _this$props.isOneApp,
        isOOI = _this$props.isOOI,
        appSettings = _this$props.appSettings,
        richContent = _this$props.richContent,
        htmlIframeSrc = _this$props.htmlIframeSrc,
        isMobile = _this$props.isMobile,
        isInEditor = _this$props.isInEditor,
        isInPreview = _this$props.isInPreview;
    this.rce = richContent;
    var _this$rce = this.rce,
        giphyTypeMapper = _this$rce.giphyTypeMapper,
        videoTypeMapper = _this$rce.videoTypeMapper,
        imageTypeMapper = _this$rce.imageTypeMapper,
        galleryTypeMapper = _this$rce.galleryTypeMapper,
        dividerTypeMapper = _this$rce.dividerTypeMapper,
        htmlTypeMapper = _this$rce.htmlTypeMapper,
        linkTypeMapper = _this$rce.linkTypeMapper,
        TEXT_COLOR_TYPE = _this$rce.TEXT_COLOR_TYPE,
        HTML_TYPE = _this$rce.HTML_TYPE,
        IMAGE_TYPE = _this$rce.IMAGE_TYPE,
        VIDEO_TYPE = _this$rce.VIDEO_TYPE,
        GALLERY_TYPE = _this$rce.GALLERY_TYPE,
        LINK_TYPE = _this$rce.LINK_TYPE;
    this.typeMappers = (0, _lodash.compact)([videoTypeMapper, imageTypeMapper, galleryTypeMapper, dividerTypeMapper, htmlTypeMapper, giphyTypeMapper, enableLinks && linkTypeMapper]);

    if (enableLinks && isOneApp) {
      this.oneAppLinkConfig = {
        onClick: function onClick(event, url) {
          event.preventDefault();

          _this3.props.actions.openUrl({
            url: url
          });
        }
      };
    }

    this.helpers = {};
    this.initTheme();
    var isExpandEnabled = this.props.fullscreenComponent && !(isMobile || isInEditor() || isInPreview());

    if (isExpandEnabled) {
      this.helpers.onExpand = this.onExpandImage;
    }

    var colorScheme = (0, _textColorUtils.getTextColorSchema)(appSettings);
    this.config = (_this$config = {}, _this$config[TEXT_COLOR_TYPE] = {
      customStyleFn: (0, _textColorUtils.viewerCustomStyleFn)(colorScheme, richContent),
      styleSelectionPredicate: (0, _textColorUtils.styleSelectionPredicate)(colorScheme, richContent)
    }, _this$config[HTML_TYPE] = {
      htmlIframeSrc: htmlIframeSrc
    }, _this$config[IMAGE_TYPE] = this.getImagePluginConfig(), _this$config[VIDEO_TYPE] = this.getVideoPluginConfig(), _this$config[GALLERY_TYPE] = {
      imageProps: function imageProps() {
        return {
          'data-pin-url': _this3.props.pageUrl
        };
      }
    }, _this$config[LINK_TYPE] = this.oneAppLinkConfig, _this$config);
    var useCustomScroll = !isOOI || isOOI && (isInEditor() || isInPreview());

    if (useCustomScroll && this.config[GALLERY_TYPE]) {
      this.config[GALLERY_TYPE].scrollingElement = function () {
        return {
          addEventListener: function addEventListener(eventName, callback) {
            _wixSdkPolyfill["default"].addEventListener(eventName.toUpperCase(), callback);
          },
          removeEventListener: function removeEventListener(eventName, callback) {
            _wixSdkPolyfill["default"].removeEventListener(eventName.toUpperCase(), callback);
          }
        };
      };
    }

    this.initDecorators();
    this.initInlineStyleMappers(this.config);
  };

  _proto.initTheme = function initTheme() {
    var _this$props2 = this.props,
        appSettings = _this$props2.appSettings,
        richContentFontClassName = _this$props2.richContentFontClassName,
        useDescriptionFontInEditor = _this$props2.useDescriptionFontInEditor,
        isPostPageEnabled = _this$props2.isPostPageEnabled,
        isCompact = _this$props2.isCompact,
        isSeo = _this$props2.isSeo,
        isMobile = _this$props2.isMobile,
        emotion = _this$props2.emotion,
        isPostPageBundle = _this$props2.isPostPageBundle,
        isOOI = _this$props2.isOOI;
    var isPostPage = isPostPageBundle();
    this.theme = (0, _theme["default"])({
      appSettings: appSettings,
      readOnly: true,
      isCompact: isCompact,
      isViewer: true,
      isSeo: isSeo,
      isOOI: isOOI,
      isMobile: isMobile,
      isPostPageEnabled: isPostPageEnabled,
      richContentFontClassName: richContentFontClassName,
      useDescriptionFontInEditor: useDescriptionFontInEditor && isPostPageEnabled,
      isPostPage: isPostPage,
      css: emotion.css
    });
    this.style = (0, _getStyle["default"])(appSettings, {
      isPostPageEnabled: isPostPageEnabled
    });
  };

  _proto.initDecorators = function initDecorators() {
    var _createHeadersMarkdow;

    var _this$rce2 = this.rce,
        HashtagDecorator = _this$rce2.HashtagDecorator,
        HEADERS_MARKDOWN_TYPE = _this$rce2.HEADERS_MARKDOWN_TYPE,
        createHeadersMarkdownDecorator = _this$rce2.createHeadersMarkdownDecorator,
        CodeBlockDecorator = _this$rce2.CodeBlockDecorator;
    this.decorators = (0, _lodash.compact)([new HashtagDecorator({
      theme: this.theme,
      onClick: this.onHashTagClick,
      createHref: _searchPageUrl.createHashtagHref
    }), createHeadersMarkdownDecorator((_createHeadersMarkdow = {}, _createHeadersMarkdow[HEADERS_MARKDOWN_TYPE] = {
      hideMarkdown: true
    }, _createHeadersMarkdow)), CodeBlockDecorator && new CodeBlockDecorator({
      theme: this.theme
    })]);
  };

  _proto.initInlineStyleMappers = function initInlineStyleMappers(config) {
    this.inlineStyleMappers = [this.rce.textColorInlineStyleMapper(config, this.props.initialRawState)];
  };

  RichContentViewer.getDerivedStateFromError = function getDerivedStateFromError(error) {
    return {
      error: error
    };
  };

  _proto.render = function render() {
    var _this4 = this;

    var _this$state = this.state,
        error = _this$state.error,
        isExpandMode = _this$state.isExpandMode,
        expandModeImageIndex = _this$state.expandModeImageIndex;

    if (error) {
      return this.props.fallback();
    }

    var _this$props3 = this.props,
        initialRawState = _this$props3.initialRawState,
        viewerKey = _this$props3.viewerKey,
        relValue = _this$props3.relValue,
        isMobile = _this$props3.isMobile,
        isInEditor = _this$props3.isInEditor,
        isSeo = _this$props3.isSeo,
        isSSR = _this$props3.isSSR,
        Fullscreen = _this$props3.fullscreenComponent;
    var _this$theme = this.theme,
        advancedPostOpts = _this$theme.advancedPostOpts,
        blogSharedValues = _this$theme.blogSharedValues;

    if (isInEditor()) {
      this.initTheme();
    }

    var Viewer = this.Viewer;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: this.style,
      className: (0, _classnames["default"])(_richContentViewer["default"].container, this.theme.overrideDefaultTheme, this.theme.overrideAppSettings)
    }, /*#__PURE__*/_react["default"].createElement(Viewer, _extends({}, this.props, {
      key: "" + advancedPostOpts + blogSharedValues.colors.linkHashtagColor + viewerKey,
      typeMappers: this.typeMappers,
      ref: function ref(_ref) {
        return _this4.editor = _ref;
      },
      initialState: initialRawState,
      helpers: this.helpers,
      decorators: this.decorators,
      seoMode: isSeo,
      theme: this.theme,
      platform: isMobile ? 'mobile' : 'desktop',
      anchorTarget: anchorTarget,
      relValue: relValue,
      config: this.config,
      inlineStyleMappers: this.inlineStyleMappers,
      disabled: this.state.isViewerDisabled,
      onError: this.onError
    })), !isSSR && Fullscreen && /*#__PURE__*/_react["default"].createElement(Fullscreen, {
      isOpen: isExpandMode,
      images: this.getExpandModeImages().images,
      onClose: function onClose() {
        return _this4.setState({
          isExpandMode: false
        });
      },
      index: expandModeImageIndex
    }));
  };

  return RichContentViewer;
}(_react.Component);

RichContentViewer.defaultProps = {
  isCompact: false,
  useDescriptionFontInEditor: true,
  relValue: 'noreferrer',
  fallback: function fallback() {
    return 'Content cannot be displayed';
  }
};
var _default = RichContentViewer;
exports["default"] = _default;